﻿export class Helper
{
    public static awaitTime(timeMS:number):Promise<void>
    {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>resolve(), timeMS);
        })
    }
}